// 每次生成的地图都可以通过对应的dom ID找到，方便做后续处理
let mapObj = {};
let autoComplete = {};
let heatMap = {};
let circle = {};
import urlImgStarting from '../../../static/images/03_icon_起点.png'
import urlImgEnd from '../../../static/images/03_icon_终点.png'
export default {
  /* 加载地图插件并配置地图版本及key
    version:amap高德地图js API版本号
    key:高的地图官方平台申请的可使用的key
    callback:回调函数名称，需提前定义好此具名函数
  */
  loaded (version, key, callbackName,mapSecret) {
    if(mapSecret){
      window._AMapSecurityConfig = {
        securityJsCode:mapSecret,
      }
    }
    let url = 'https://webapi.amap.com/maps?v=' + (version ? version : '1.4.13') + '&key=' + (key ? key :'e8de119b94b66d5af80d2b9cb547a6d4');
    if (callbackName){
      url += '&callback=' + callbackName;
    }
    let amapDom = document.createElement('script');
    // console.log('url', url);
    amapDom.src = url;
    amapDom.charset = 'utf-8';
    amapDom.type = 'text/javascript';
    document.head.appendChild(amapDom);
  }
  /** 初始化地图
   * domId:绘制到页面的DOM的ID
   * lng:经度
   * lat:纬度
   * zoom:区域缩放等级
   * **/
  , initMap(domId, {lng, lat, zoom}){
    let data={
      viewMode:'2D'
      ,lang:'zh_cn'
    };
    if(zoom){
      data.zoom=zoom;
    }
    if(lng&&lat){
      data.center=[lng, lat]
    }

    mapObj[domId] = new AMap.Map(domId,data);
    return mapObj[domId]
  }
  // 修改地图中心点
  , setCenter(domId, lng, lat){
    if (mapObj[domId]) {
      mapObj[domId].setCenter([lng, lat]);
    }
  }
  // 地图行走起点和终点
  , setSearch(domId, lng, lat){
    if (mapObj[domId]) {
      AMap.plugin('AMap.Riding',function(){//回调函数
        let ridingOption = {
          policy: 1
        }
        let riding = new AMap.Riding(ridingOption)
        //根据起终点坐标规划骑行路线
        riding.search(lng,lat, function(status, result) {
          // result即是对应的公交路线数据信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_RidingResult
          if (status === 'complete') {
            // log.success('骑行路线数据查询成功')
            drawRoute(result.routes[0])
          } else {
            // log.error('骑行路线数据查询失败' + result)
          }
        });
        function drawRoute (route) {
          let path = parseRouteToPath(route)

          let startMarker = new AMap.Marker({
            position: path[0],
            icon: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
            map: mapObj[domId]
          })

          let endMarker = new AMap.Marker({
            position: path[path.length - 1],
            icon: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
            map: mapObj[domId]
          })

          let routeLine = new AMap.Polyline({
            path: path,
            isOutline: true,
            outlineColor: '#ffeeee',
            borderWeight: 2,
            strokeWeight: 8,
            strokeOpacity:0.8,
            showDir:true,
            strokeColor: '#0091ff',
            lineJoin: 'round'
          })

          routeLine.setMap(mapObj[domId])

          // 调整视野达到最佳显示区域
          mapObj[domId].setFitView([ startMarker, endMarker, routeLine ])
        }

        // 解析RidingRoute对象，构造成AMap.Polyline的path参数需要的格式
        // RidingResult对象结构参考文档 https://lbs.amap.com/api/javascript-api/reference/route-search#m_RideRoute
        function parseRouteToPath(route) {
          let path = []

          for (let i = 0, l = route.rides.length; i < l; i++) {
            let step = route.rides[i]

            for (let j = 0, n = step.path.length; j < n; j++) {
              path.push(step.path[j])
            }
          }

          return path
        }
      })
    }
  }
  // 地图轨迹
  ,mapPath(domId, lineData){
    if (mapObj[domId]) {
      let startMarker, endMarker, lineArr = lineData
      // 起点
      startMarker = new AMap.Marker({
        map: mapObj[domId],
        position:  lineArr[0],
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
        // offset: new AMap.Pixel(-26, -13),
        // autoRotation: true,
        // angle:-90,
      });
      // 终点
      endMarker = new AMap.Marker({
        map: mapObj[domId],
        position:  lineArr[lineArr.length - 1],
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
        // offset: new AMap.Pixel(-26, -13),
        // autoRotation: true,
        // angle:-90,
      });
      // 绘制轨迹
      let polyline = new AMap.Polyline({
        map: mapObj[domId],
        path: lineArr,
        isOutline: true,
        outlineColor: '#ffeeee',
        borderWeight: 2,
        strokeWeight: 8,
        strokeOpacity:0.8,
        showDir:true,
        strokeColor: '#0091ff',
        lineJoin: 'round'
      });
      polyline.setMap(mapObj[domId])
      // 调整视野达到最佳显示区域
      mapObj[domId].setFitView(polyline);
    }
  }
  // 销毁地图
  ,destroyMap(domId){
    if (mapObj[domId]){
      mapObj[domId].destroy();
      mapObj[domId] = null;
    }
  }
  // 清除地图覆盖物
  , clearMap(domId){
    if (mapObj[domId]) {
      mapObj[domId].clearMap();
    }
  }
  // 添加点标记
  , addMarker(domId, { lng, lat, icon, shadow, offset, label, zIndex, draggable, zoom }, callbackOptions){
    if (mapObj[domId]){
      let options = {
        position: [lng, lat]
        , label: label?label:null
        , zIndex: zIndex?zIndex:100
      }
      if(icon && typeof icon == 'object'){
        let mapicon={
          image:icon.image,
          size:new AMap.Size(icon.width, icon.height),
          imageSize:new AMap.Size(icon.width, icon.height)
        }
        options.icon = new AMap.Icon(mapicon);
      }
      if (shadow && typeof shadow == 'object') {
				let shadow1={
					image:shadow.image,
					imageSize:new AMap.Size(shadow.imageSize[0], shadow.imageSize[1]),
					size:new AMap.Size(shadow.size[0], shadow.size[1]),
					imageOffset:new AMap.Pixel(shadow.imageOffset[0], shadow.imageOffset[1])
				}
        options.shadow = new AMap.Icon(shadow1);
      }
      if (draggable){
        options.draggable = draggable;
      }
      if (offset){
				let offset1=new AMap.Pixel(offset[0], offset[1])
        options.offset = new AMap.Pixel(offset1.x, offset1.y);
      }
      let marker = new AMap.Marker(options);
      mapObj[domId].add(marker);
      let position = marker.getPosition();
      if (position && position.lng && position.lat){
        mapObj[domId].setZoomAndCenter(zoom, [position.lng, position.lat]);
      }
      //type == 'all',并触发回调
      if (callbackOptions && callbackOptions.type && callbackOptions.type == 'all'){
        callbackOptions.callback && typeof callbackOptions.callback == 'function' && callbackOptions.callback(position);
      }
      //type == 'dragend' 点可拖拽，并触发回调
      marker.on('dragend', ()=>{
        let position = marker.getPosition();
        if (callbackOptions && callbackOptions.type && (callbackOptions.type == 'dragend' || callbackOptions.type == 'all')){
          callbackOptions.callback && typeof callbackOptions.callback == 'function' && callbackOptions.callback(position);
        }
      })
      //type == 'click' 点击，触发回调
      marker.on('click', () => {
        let position = marker.getPosition();
        if (callbackOptions && callbackOptions.type && callbackOptions.type == 'click') {
          callbackOptions.callback && typeof callbackOptions.callback == 'function' && callbackOptions.callback(position);
        }
      })
    }
  }
  // 自动调整显示所有覆盖物
  , setFitView(domId){
    if (mapObj[domId]){
      mapObj[domId].setFitView();
    }
  }
  // 地址自动补全
  , autoComplete(key, cityCode, callback){
    AMap.plugin('AMap.Autocomplete',()=>{
      let autoOptions = {
        city: cityCode ? cityCode:'全国'
        , datatype:'all'
        , citylimit:true
      }
      autoComplete = new AMap.Autocomplete(autoOptions);
      autoComplete.search(key, (status, result) => {
        if (status == 'complete'&&result.info == 'OK') {
          let positionList = result.tips.filter((poi) => {
            return !(poi.name.indexOf("公交站") != -1 || poi.name.indexOf("地铁站") != -1 || typeof (poi.location) == 'undefined' || poi.location == '');
          })
          callback && typeof callback == 'function' && callback(positionList);
        }
      })
    })
  }
  // 重新设置自动补全城市限制
  , setCity(mapId, cityCode){
    if (mapObj[mapId]){
      mapObj[mapId].setCity(cityCode);
    }
  }
  // 设置地图显示区域
  , setArea(mapId, adCode){
    if (mapObj[mapId]) {
      mapObj[mapId].setCity(adCode);
    }
  }
  // 添加并绘制多边形
  ,addPolygon(mapId, options, callback){
    if (mapObj[mapId]){
      mapObj[mapId].plugin(["AMap.MouseTool"], ()=>{
        let mousetool = new AMap.MouseTool(mapObj[mapId]);
        if (options.toString() != '{}'){
          mousetool.polygon(options);
        }else{
          mousetool.polygon();
        }
        mousetool.on('draw',(polygon)=>{
          mousetool.close();
          callback && typeof callback == 'function' && callback(polygon.obj);
        })
      })
    }
  }
  // 显示多边形
  , newPolygon(mapId, options, callback){
    if (mapObj[mapId] && options.path){
      let polygon = new AMap.Polygon(options);
      polygon.setMap(mapObj[mapId]);
      // callback && typeof callback == 'function' && callback(data.target);
      polygon.on('mousedown',(e)=>{
        callback && typeof callback == 'function' && callback(e);
      })
    }
  }
  // 显示多边形  市场管理模块选择范围用 新写的方法是为了不影响上面的方法
  , newMarketPolygon(mapId, options, callback){
    if (mapObj[mapId] && options.path){
      let polygon = new AMap.Polygon(options);
      polygon.setMap(mapObj[mapId]);
      return polygon;
    }
  }
  // 编辑多边形
  , editPolygon(mapId, options, callback){
    if (mapObj[mapId] && options.path){
      let polygon = new AMap.Polygon(options);
      polygon.setMap(mapObj[mapId]);
      mapObj[mapId].plugin(['AMap.PolyEditor'],()=>{
        let editPolygon = new AMap.PolyEditor(mapObj[mapId], polygon);
        editPolygon.open();
        mapObj[mapId].on('rightclick',(e)=>{
          editPolygon.close();
        })
        polygon.on('rightclick', (e) => {
          editPolygon.close();
        })
        editPolygon.on('end', (data)=>{
          // console.log('editPolygon', data.target);
          callback && typeof callback == 'function' && callback(data.target);
        })
      })
    }
  }
  // 关闭多边形编辑模式
  , closePolygon(editPolygon){
    editPolygon.close();
  }
  // 清除覆盖物（分类型）
  , clearOverlays(mapId, type, callback){
    if (mapObj[mapId]){
      let overlays = mapObj[mapId].getAllOverlays(type);
      mapObj[mapId].remove(overlays);
      callback && typeof callback == 'function' && callback();
    }
  }
  // 绘制圆形
  , drawCircle(mapId, lng, lat, options, {type, callback}){
    if (mapObj[mapId]){
      circle[options.id] = new AMap.Circle({
        map: mapObj[mapId],
        center: [lng, lat],
        radius: options.radius || 100,  // 半径
        fillColor:options.fillColor || 'red',  // 圆形填充颜色
        strokeColor: options.strokeColor || '#fff', // 描边颜色
        strokeWeight: options.strokeWeight || 0,  // 描边宽度
        strokeOpacity: options.strokeOpacity || 0.2, // 描边透明度
        fillOpacity: options.fillOpacity || 0.25,  // 圆形填充透明度
      })
      function clickCallback(event) {
        if (type && type == 'click') {
          // console.log('aaaa', event, circle[options.id]);
          callback && typeof callback == 'function' && callback(event);
        }
      }
      circle[options.id].on('click', clickCallback);
    }
  }
  // 生产热力图
  , heatMap(mapId, heatMapId, option, heatmapData){
    // 判断浏览器是否支持canvas
    const isSupportCanvas = () => {
      let elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    }
    if (!isSupportCanvas()){
      alert('热力图仅对支持canvas的浏览器适用,您所使用的浏览器不能使用热力图功能,请换个浏览器试试');
    }
    if (mapObj[mapId]){
      mapObj[mapId].plugin(['AMap.Heatmap'], () => {
        // 初始化heatmap对象
        if (!heatMap[heatMapId]){
          heatMap[heatMapId] = new AMap.Heatmap(mapObj[mapId], {
            radius: option.radius || 30, // 默认给定半径30
            opacity:[0, 1],
            gradient:{
              0.1:'#5c49b0',
              0.2:'#38bcf7',
              0.4:'#4acf0b',
              0.6:'#ffeb00',
              1.0:'#e73a00'
            }
          })
        }
        // 设置数据集
        heatMap[heatMapId].setDataSet({
          data: heatmapData,
          max: option.max || 30
        })
      })
    }
  }

	//
	, getInfoWindow(){
		return new AMap.InfoWindow({
		  offset: new AMap.Pixel(0, 0),
		});
	}
}



// WEBPACK FOOTER //
// core-dms/projects/candao-dms-std/index/plugs/amap/index.js